import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchConsents = async ({ patientId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);

  const URL = `${__API_URL__}/api/appiell/patient/consent?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetConsent = ({ patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["consent", patientId],
    queryFn: () => fetchConsents({ patientId }),
    enabled: enabled && Boolean(patientId && patientId > 0),
  });
};

export default useGetConsent;
